module.exports = __webpack_public_path__ + "img/makeup.eee0cb0b.jpg";